import type { ReactNode } from 'react'
import { ChevronDownIcon } from '@/shared/ui/icons/ChevronDownIcon'
import { ChevronUpIcon } from '@/shared/ui/icons/ChevronUpIcon'

export function SelectBox({
  label,
  size = 'default',
  isOpen = false,
  isDisabled = false,
  onClick,
  className = '',
}: {
  label: ReactNode
  size?: 'default' | 'small' | 'pc'
  isOpen?: boolean
  isDisabled?: boolean
  onClick?: () => void
  className?: string
}) {
  // 가로 여백을 사이즈마다 갖는다 — 바탕 클래스에 두면 `pc` 의 16px 과 겹친다.
  const box =
    size === 'small'
      ? 'h-8 rounded-lg px-3 text-label'
      : // 시안 1288:22863 — PC 등록 화면의 드롭다운은 48px · radius 12 · 여백 16 · 글자 16 이다.
        size === 'pc'
        ? 'h-12 rounded-xl px-4 text-body-md'
        : 'h-10 rounded-lg px-3 text-body-sm'

  const tone = isDisabled
    ? 'border-white-400 bg-white-200 text-white-800 cursor-not-allowed'
    : isOpen
      ? 'border-violet-500 bg-white-50 text-black-700 cursor-pointer'
      : 'border-white-400 bg-white-50 text-black-700 hover:border-white-600 cursor-pointer'

  return (
    <button
      type="button"
      className={`flex items-center gap-2 border border-solid py-[11px] text-left ${box} ${tone} ${className}`}
      disabled={isDisabled}
      aria-expanded={isOpen}
      onClick={onClick}
    >
      <span className="min-w-0 flex-1 truncate">{label}</span>
      <span className="flex shrink-0 items-center [&>svg]:h-5 [&>svg]:w-5" aria-hidden>
        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </span>
    </button>
  )
}
